import { getQueryMethod, resources, entities, getURLParams } from '../utils';
const { meloAPI } = resources;
const { payments } = entities;

const query = getQueryMethod(meloAPI, payments);

const endpoints = {
  getPayoutsPaginated: async ({ businessId, ...params }) => {
    const queryParams = getURLParams({ ...params });
    return await query(`paginated/${businessId}?${queryParams}`);
  },
  getPayout: async (businessId, payoutId) => {
    return await query(`one/${businessId}/${payoutId}`);
  },
  getPaymentAndChargesSummary: async ({ businessId, ...params }) => {
    const queryParams = getURLParams({ ...params });
    return await query(`summary/${businessId}?${queryParams}`);
  },
  getPricing: async (businessId) => {
    const path = businessId ? `pricing/${businessId}` : 'pricing';
    return await query(path);
  },
  getPseBanks: async () => {
    return await query(`pseBanks`);
  }
};

export default endpoints;
